<div class="content-wrapper">

  <div class="title-container">
    <div class="title">{{'musicChannel.label.title' | translate }}</div>

    <button class="icon-button" (click)="onClose()">
      <tun-close-v5 class="icon icon-large-scaled-svg-button"></tun-close-v5>
    </button>

  </div>

  @if ((musicChannelsLoading$ | async)) {
    <div class="loaderContainer">
      <mat-spinner class="loading-spinner"></mat-spinner>
      <span class="loadingText">{{'general.status.loading' | translate}}</span>
    </div>
  }
  @if ((musicChannelsLoadingError$ | async)) {
    <div class="errorContainer">
      <p>{{'general.status.error.message' | translate}}</p>
      <button (click)="onRetry()" class="retryButton">
        <p>
          {{'general.status.error.retry' | translate }}
        </p>
      </button>
    </div>
  }
  @if (!(musicChannelsLoading$ | async) && !(musicChannelsLoadingError$ | async)) {
    <div class="scrollContainer">
      @for (musicChannelGroup of (musicChannelGroups$ | async); track musicChannelGroup; let i = $index) {
        <tun-music-channel-group-view
          class="musicChannelGroup {{ i == 0 ? 'first' : ''}}"
          [musicChannelGroup]="musicChannelGroup"
          (showDetails)="onShowDetails($event)"
          [scaleContent]="0.8"
        ></tun-music-channel-group-view>
      }
    </div>
  }

</div>
